module.exports = __webpack_public_path__ + "img/couples_02_V.12754861.webp";